import { Drawer, Stack } from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useState, type FC, type ReactNode } from "react";

import "./SetupDrawer.scss";
import { isMobile } from "react-device-detect";
import { WemeInvite } from "../weme-invite/WemeInvite";

interface SetupDrawerProps {
  children: ReactNode;
  withInvite?: boolean;
}

export const SetupDrawer: FC<SetupDrawerProps> = ({ children, ...props }) => {
  const { withInvite } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Causing the open animation
    const timeout = setTimeout(() => setOpen(true), 0);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      {isMobile && withInvite && <WemeInvite />}
      {isMobile ?
        <Drawer
          transitionDuration={withInvite ? 1200 : 300}
          anchor="bottom"
          hideBackdrop
          PaperProps={{ sx: { bgcolor: "transparent" } }}
          disablePortal
          open={open}
        >
          <Stack
            borderRadius="12vw 12vw 0 0  "
            bgcolor="#fff"
            height="max-content"
            maxHeight={withInvite ? "82vh" : "90vh"}
          >
            {children}
          </Stack>
        </Drawer>
        : <motion.div className="setup-container" initial={{ opacity: 0 }} animate={{ opacity: 1, x: [120, 0] }} transition={{ duration: 1 }}>{children}</motion.div>}
    </>
  );
};
